// @ts-check
import { z } from 'zod';

const Permission = z.object({
  id: z.number(),
  name: z.string(),
  slug: z.string(),
});

export default Permission;
